import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from '../../shared/services/http.service';
import { GatewayListItem } from '../../site-gateway/models/gateway';
import { SetupId } from '../models/Site';

import { SetupGateway } from './SetupGateway';

@Injectable({ providedIn: 'root' })
export class HttpSetupGateway implements SetupGateway {
    private httpService = inject(HttpService);

    fetchGateways(setupId: SetupId): Observable<GatewayListItem[]> {
        return this.httpService.get(`/v1/site/${setupId}/gateways`);
    }
}
